(() => {
  function buildTryOnUrl(card) {
    const style = card.dataset.tryonStyleId;
    const tone = card.dataset.tryonTone || 'light';
    const view = card.dataset.tryonView || 'p4_thumb_visible';
    const baseUrl = card.dataset.tryonUrl || '/pages/virtual-try-on';

    const url = new URL(baseUrl, window.location.href);
    if (!url.searchParams.has('style')) url.searchParams.set('style', style);
    if (!url.searchParams.has('tone')) url.searchParams.set('tone', tone);
    if (!url.searchParams.has('view_mode') && !url.searchParams.has('tryon_view')) {
      url.searchParams.set('view_mode', view);
    }
    if (!url.searchParams.has('render')) url.searchParams.set('render', '1');
    if (!url.hash && card.dataset.tryonAnchor) url.hash = card.dataset.tryonAnchor;

    const productCard = card.closest('.product-main__card');
    const variantControl = productCard?.querySelector('form[action*="/cart/add"] [name="id"]');
    if (variantControl?.value) url.searchParams.set('variant', variantControl.value);

    return url.toString();
  }

  function initPromos() {
    document.querySelectorAll('[data-nail-tryon-promo]').forEach((card) => {
      if (card.dataset.tryonPromoInitialized === 'true') return;
      card.dataset.tryonPromoInitialized = 'true';

      const link = card.querySelector('[data-nail-tryon-link]');
      if (!link) return;

      link.addEventListener('click', (event) => {
        const mode = card.dataset.tryonMode || 'page';
        const anchor = card.dataset.tryonAnchor || '#nail-tryon';
        const target = document.querySelector(anchor);

        if (mode !== 'embedded' || !target) {
          link.href = buildTryOnUrl(card);
          return;
        }

        event.preventDefault();
        link.href = anchor;
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });

        document.dispatchEvent(new CustomEvent('nail-tryon:open', {
          detail: {
            styleId: card.dataset.tryonStyleId,
            tone: card.dataset.tryonTone || 'light',
            view: card.dataset.tryonView || 'p4_thumb_visible',
            render: true
          }
        }));
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPromos);
  } else {
    initPromos();
  }

  document.addEventListener('shopify:section:load', initPromos);
})();
